"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimePicker = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var invariant_1 = __importDefault(require("../util/invariant"));
var dom_helpers_1 = require("../util/dom-helpers");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var dates_1 = __importDefault(require("../util/dates"));
var date_arithmetic_1 = __importDefault(require("../util/date-arithmetic"));
var localizers_1 = require("../util/localizers");
var popup_1 = require("../popup");
var calendar_1 = require("../calendar");
var time_list_1 = require("./time-list");
var date_input_1 = require("./date-input");
var custom_prop_types_1 = __importDefault(require("../util/custom-prop-types"));
var widget_helpers_1 = require("../util/widget-helpers");
var focus_mixin_1 = require("../mixins/focus-mixin");
var vdl_prefix_1 = require("../util/vdl-prefix");
var calendar_2 = __importDefault(require("adp-react-icons/lib/fa/calendar"));
var clock_o_1 = __importDefault(require("adp-react-icons/lib/fa/clock-o"));
var timeout_manager_1 = require("../util/timeout-manager");
var popup_scroll_manager_1 = require("../util/popup-scroll-manager");
var popups = {
  TIME: 'time',
  CALENDAR: 'calendar'
};
var views = {
  MONTH: 'month',
  YEAR: 'year',
  DECADE: 'decade',
  CENTURY: 'century'
};
var viewEnum = Object.keys(views).map(function (k) {
  return views[k];
});
function localizedMessage(messageKey, locale) {
  return localizers_1.message.formatMessage('adp-react-components/date-time-picker/' + messageKey, undefined, locale);
}
function msgs(msgs, locale) {
  return Object.assign({
    calendarButton: localizedMessage('SELECT_DATE', locale),
    timeButton: localizedMessage('SELECT_TIME', locale)
  }, msgs);
}
function getFormat(props) {
  var cal = props[popups.CALENDAR] != null ? props.calendar : true;
  var time = props[popups.TIME] != null ? props.time : true;
  return props.format ? props.format : cal && time || !cal && !time ? localizers_1.date.getFormat('default', undefined) : localizers_1.date.getFormat(cal ? 'date' : 'time', undefined);
}
function formatDate(date, format, locale) {
  var val = '';
  if (date instanceof Date && !isNaN(date.getTime())) {
    val = localizers_1.date.format(date, format, locale);
  }
  return val;
}
function formatsParser(formats, locale, str) {
  var date;
  for (var i = 0; i < formats.length; i++) {
    date = localizers_1.date.parse(str, formats[i], locale);
    if (date) {
      return date;
    }
  }
  return null;
}
function dateOrNull(dt) {
  if (dt && !isNaN(dt.getTime())) {
    return dt;
  }
  return null;
}
var DateTimePicker = /** @class */function (_super) {
  __extends(DateTimePicker, _super);
  function DateTimePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._timeoutManager = new timeout_manager_1.TimeoutManager();
    _this._popupScrollManager = new popup_scroll_manager_1.PopupScrollManager();
    _this._isMounted = false;
    _this.state = {
      focused: false,
      open: _this.props.open !== undefined ? _this.props.open : _this.props.defaultOpen || false,
      currentDate: _this.props.currentDate !== undefined ? _this.props.currentDate : _this.props.defaultCurrentDate || new Date()
    };
    _this.setTimeout = function (key, callback, duration) {
      if (_this._isMounted) {
        return _this._timeoutManager.setTimeout(key, callback, duration);
      }
    };
    _this.handleBlur = function (event) {
      var date = _this._valueInput.props.value;
      var onComponentBlur = _this.props.onComponentBlur;
      focus_mixin_1.handleBlur(_this, event, function (focused) {
        if (!focused) {
          _this.close();
          if (onComponentBlur) {
            onComponentBlur(date);
          }
        }
      });
    };
    _this.handleFocus = function (event) {
      focus_mixin_1.handleFocus(_this, event);
    };
    _this.handleAriaActiveDescendant = function (id) {
      if (id === _this.state.ariaActiveDescendant) {
        return;
      }
      _this.setState({
        ariaActiveDescendant: id
      });
    };
    _this._scrollTo = function (selected, list, focused) {
      return _this._popupScrollManager.scrollTo(selected, list, focused, _this.props.onMove);
    };
    //FIXME @widgetEditable
    _this._change = function (date, str, constrain) {
      var _a = _this.props,
        onChange = _a.onChange,
        value = _a.value;
      if (constrain) {
        date = _this.inRangeValue(date);
      }
      if (onChange) {
        if (date == null || value == null) {
          if (date != value) {
            //eslint-disable-line eqeqeq
            onChange(date || undefined, str);
          }
        } else if (!date_arithmetic_1.default.eq(date, value)) {
          onChange(date, str);
        }
      }
    };
    //FIXME @widgetEditable
    _this._keyDown = function (e) {
      var _a = _this.props,
        calendar = _a.calendar,
        time = _a.time;
      var open = _this.state.open;
      widget_helpers_1.notify(_this.props.onKeyDown, [e]);
      if (e.defaultPrevented) {
        return;
      }
      if (e.key === 'Escape' && open) {
        _this.close();
      } else if (e.altKey) {
        e.preventDefault();
        if (e.key === 'ArrowDown') {
          if (calendar && time) {
            _this.open(open === popups.CALENDAR ? popups.TIME : popups.CALENDAR);
          } else if (time) {
            _this.open(popups.TIME);
          } else if (calendar) {
            _this.open(popups.CALENDAR);
          }
        } else if (e.key === 'ArrowUp') {
          _this.close();
        }
      } else if (open) {
        if (open === popups.CALENDAR) {
          _this._calendarPopup._keyDown(e);
        }
        if (open === popups.TIME) {
          _this._timePopup._keyDown(e);
        }
      }
    };
    //FIXME @widgetEditable
    _this._keyPress = function (e) {
      widget_helpers_1.notify(_this.props.onKeyPress, [e]);
      if (e.defaultPrevented) {
        return;
      }
      if (_this.state.open === popups.TIME) {
        _this._timePopup._keyPress(e);
      }
    };
    _this.focus = function () {
      if (dom_helpers_1.activeElement() !== react_dom_1.default.findDOMNode(_this._valueInput)) {
        _this._valueInput.focus();
      }
    };
    //FIXME @widgetEditable
    _this._selectDate = function (date) {
      var format = getFormat(_this.props);
      var dateTime = dates_1.default.mergeTime(date, _this.props.value, _this.state.currentDate);
      var dateStr = formatDate(date, format, _this.props.locale);
      _this.close();
      widget_helpers_1.notify(_this.props.onSelect, [dateTime, dateStr]);
      _this._change(dateTime, dateStr, true);
      _this.focus();
    };
    //FIXME @widgetEditable
    _this._selectTime = function (datum) {
      var format = getFormat(_this.props);
      var dateTime = dates_1.default.mergeTime(_this.props.value, datum.date, _this.state.currentDate);
      var dateStr = formatDate(datum.date, format, _this.props.locale);
      _this.close();
      widget_helpers_1.notify(_this.props.onSelect, [dateTime, dateStr]);
      _this._change(dateTime, dateStr, true);
      _this.focus();
    };
    _this.hasNoLetters = function (str) {
      return str === str.replace(/[aA-zZ]/g, '');
    };
    //FIXME @widgetEditable
    _this._click = function (view) {
      _this.focus();
      _this.toggle(view);
    };
    _this._parse = function (str) {
      if (str && str.length === 3 && _this.hasNoLetters(str)) {
        str = "0" + str;
      }
      var format = getFormat(_this.props);
      var editFormat = _this.props.editFormat;
      var parse = _this.props.parse;
      var formats = [];
      if (typeof parse === 'function') {
        return parse(str, _this.props.locale);
      }
      if (Array.isArray(parse)) {
        formats = formats.concat(_this.props.parse);
      }
      if (typeof editFormat === 'string') {
        formats.push(editFormat);
      }
      if (typeof format === 'string') {
        formats.push(format);
      }
      invariant_1.default(formats.length > 0, 'adp-react-components: there are no specified `parse` formats provided and the `format` prop is a function. ' + 'the DateTimePicker is unable to parse `%s` into a dateTime, ' + 'please provide either a parse function or Globalize.js compatible string for `format`', str);
      return formatsParser(formats, _this.props.locale, str);
    };
    _this.toggle = function (view) {
      if (_this.state.open) {
        if (_this.state.open !== view) {
          _this.open(view);
        } else {
          _this.close();
        }
      } else {
        _this.open(view);
      }
    };
    _this.open = function (view) {
      if (_this.state.open !== view && _this.props[view] === true) {
        _this.setState({
          open: view
        }, function () {
          widget_helpers_1.notify(_this.props.onToggle, view);
        });
      }
    };
    _this.close = function () {
      if (_this.state.open) {
        _this.setState({
          open: false
        }, function () {
          widget_helpers_1.notify(_this.props.onToggle, false);
        });
      }
    };
    _this.inRangeValue = function (value) {
      if (value == null) {
        return value;
      }
      return date_arithmetic_1.default.max(date_arithmetic_1.default.min(value, _this.props.max), _this.props.min);
    };
    _this.handleCurrentDateChange = function (currentDate) {
      if (date_arithmetic_1.default.eq(currentDate, _this.state.currentDate)) {
        return;
      }
      _this.setState({
        currentDate: currentDate
      }, function () {
        if (_this.props.onCurrentDateChange) {
          _this.props.onCurrentDateChange(currentDate);
        }
      });
    };
    return _this;
  }
  DateTimePicker.prototype.componentDidMount = function () {
    this._isMounted = true;
  };
  DateTimePicker.prototype.componentWillReceiveProps = function (nextProps) {
    var newState = {};
    if (nextProps.open !== undefined && nextProps.open !== this.state.open) {
      newState.open = nextProps.open;
    }
    if (nextProps.currentDate !== undefined && nextProps.currentDate !== this.state.currentDate) {
      newState.currentDate = nextProps.currentDate;
    }
    this.setState(newState);
  };
  DateTimePicker.prototype.componentWillUnmount = function () {
    this._isMounted = false;
    this._timeoutManager.clearAllTimeouts();
  };
  DateTimePicker.prototype.render = function () {
    var _a;
    var _this = this;
    var _b = this.props,
      ariaInvalid = _b.ariaInvalid,
      ariaRequired = _b.ariaRequired,
      className = _b.className,
      calendar = _b.calendar,
      time = _b.time,
      tabIndex = _b.tabIndex,
      editFormat = _b.editFormat,
      timeFormat = _b.timeFormat,
      locale = _b.locale,
      duration = _b.duration,
      step = _b.step,
      min = _b.min,
      max = _b.max,
      busy = _b.busy,
      placeholder = _b.placeholder,
      disabled = _b.disabled,
      readOnly = _b.readOnly,
      selectOnly = _b.selectOnly,
      name = _b.name,
      dropUp = _b.dropUp,
      timeComponent = _b.timeComponent,
      autoFocus = _b.autoFocus,
      ariaLabelledby = _b["aria-labelledby"],
      ariaDescribedby = _b["aria-describedby"];
    var open = this.state.open;
    var messages = msgs(this.props.messages);
    var _c = this.state,
      focused = _c.focused,
      ariaActiveDescendant = _c.ariaActiveDescendant;
    var inputID = widget_helpers_1.instanceId(this, '_input');
    var timeListID = widget_helpers_1.instanceId(this, '_time_listbox');
    var dateListID = widget_helpers_1.instanceId(this, '_cal');
    var owns = '';
    var elementProps = _1.omit(this.props, Object.keys(DateTimePicker.propTypes));
    var calProps = _1.pick(this.props, Object.keys(calendar_1.Calendar.propTypes));
    var shouldRenderList = widget_helpers_1.isFirstFocusedRender(this) || open;
    var disabledOrReadonly = selectOnly ? false : disabled || readOnly;
    var calendarIsOpen = open === popups.CALENDAR;
    var timeIsOpen = open === popups.TIME;
    if (calendar) {
      owns += dateListID;
    }
    if (time) {
      owns += ' ' + timeListID;
    }
    var value = dateOrNull(this.props.value);
    var dateTimePickerClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('date-time-picker')] = true, _a[vdl_prefix_1.vdlPrefix('date-time-picker--focus')] = focused, _a[vdl_prefix_1.vdlPrefix('date-time-picker--disabled')] = disabled, _a[vdl_prefix_1.vdlPrefix('date-time-picker--readonly')] = readOnly, _a[vdl_prefix_1.vdlPrefix('date-time-picker--both')] = calendar && time, _a[vdl_prefix_1.vdlPrefix('date-time-picker--neither')] = !calendar && !time, _a[vdl_prefix_1.vdlPrefix('date-time-picker--open')] = !!open, _a[vdl_prefix_1.vdlPrefix('date-time-picker--dropup')] = dropUp, _a);
    return react_1.default.createElement("div", __assign({}, elementProps, {
      ref: function ref(c) {
        _this._element = c;
      },
      tabIndex: -1,
      onKeyDown: this._keyDown,
      onKeyPress: this._keyPress,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      className: classnames_1.classNames(className, dateTimePickerClasses)
    }), react_1.default.createElement(date_input_1.DateInput, {
      ref: function ref(c) {
        _this._valueInput = c;
      },
      id: inputID,
      autoFocus: autoFocus,
      tabIndex: tabIndex || 0,
      role: "combobox",
      autoComplete: "off",
      "aria-invalid": ariaInvalid,
      "aria-labelledby": ariaLabelledby,
      "aria-describedby": ariaDescribedby,
      "aria-expanded": !!open,
      "aria-busy": !!busy,
      "aria-owns": owns.trim(),
      "aria-haspopup": true,
      "aria-activedescendant": ariaActiveDescendant,
      "aria-required": ariaRequired,
      placeholder: placeholder,
      name: name,
      disabled: disabled,
      readOnly: readOnly || selectOnly,
      value: value,
      format: getFormat(this.props),
      editFormat: editFormat,
      editing: focused,
      locale: locale,
      parse: this._parse,
      onChange: this._change
    }), (calendar || time) && react_1.default.createElement("span", {
      className: vdl_prefix_1.vdlPrefix('date-time-picker__select')
    }, calendar && react_1.default.createElement("button", {
      type: "button",
      tabIndex: -1,
      className: vdl_prefix_1.vdlPrefix('date-time-picker__select__picker'),
      disabled: disabledOrReadonly,
      "aria-disabled": disabledOrReadonly,
      "aria-label": messages.calendarButton,
      onClick: this._click.bind(null, popups.CALENDAR)
    }, react_1.default.createElement(calendar_2.default, {
      "aria-hidden": "true"
    })), time && react_1.default.createElement("button", {
      type: "button",
      tabIndex: -1,
      className: vdl_prefix_1.vdlPrefix('date-time-picker__select__picker'),
      disabled: disabledOrReadonly,
      "aria-disabled": disabledOrReadonly,
      "aria-label": messages.timeButton,
      onClick: this._click.bind(null, popups.TIME)
    }, react_1.default.createElement(clock_o_1.default, {
      "aria-hidden": "true"
    }))), time && react_1.default.createElement(popup_1.Popup, {
      className: vdl_prefix_1.vdlPrefix('timelist-popup'),
      dropUp: dropUp,
      open: timeIsOpen,
      duration: duration,
      onOpening: function onOpening() {
        return _this._timePopup.forceUpdate();
      }
    }, react_1.default.createElement("div", null, shouldRenderList && react_1.default.createElement(time_list_1.TimeList, {
      ref: function ref(c) {
        _this._timePopup = c;
      },
      id: timeListID,
      "aria-labelledby": inputID,
      "aria-live": open && 'polite',
      "aria-hidden": !open,
      value: value,
      format: timeFormat,
      step: step,
      min: min,
      max: max,
      currentDate: this.state.currentDate,
      locale: locale,
      onMove: this._scrollTo,
      preserveDate: !!calendar,
      itemComponent: timeComponent,
      onSelect: this._selectTime,
      onAriaActiveDescendant: this.handleAriaActiveDescendant
    }))), calendar && react_1.default.createElement(popup_1.Popup, {
      className: vdl_prefix_1.vdlPrefix('calendar-popup'),
      dropUp: dropUp,
      open: calendarIsOpen,
      duration: duration
    }, shouldRenderList && react_1.default.createElement(calendar_1.Calendar, __assign({}, calProps, {
      ref: function ref(c) {
        _this._calendarPopup = c;
      },
      tabIndex: -1,
      id: dateListID,
      value: value,
      "aria-hidden": !open,
      "aria-live": 'polite',
      onChange: this._selectDate,
      // #75: need to aggressively reclaim focus from the calendar otherwise
      // disabled header/footer buttons will drop focus completely from the widget
      onNavigate: function onNavigate() {
        return _this.focus();
      },
      currentDate: this.state.currentDate,
      onCurrentDateChange: this.handleCurrentDateChange,
      onAriaActiveDescendant: this.handleAriaActiveDescendant
    }))));
  };
  DateTimePicker.propTypes = Object.assign({}, calendar_1.Calendar.propTypes, {
    //-- controlled props -----------
    value: prop_types_1.default.instanceOf(Date),
    onChange: prop_types_1.default.func,
    onComponentBlur: prop_types_1.default.func,
    open: prop_types_1.default.oneOf([false, popups.TIME, popups.CALENDAR]),
    onToggle: prop_types_1.default.func,
    currentDate: prop_types_1.default.instanceOf(Date),
    onCurrentDateChange: prop_types_1.default.func,
    //------------------------------------
    ariaInvalid: prop_types_1.default.any,
    ariaRequired: prop_types_1.default.bool,
    defaultOpen: prop_types_1.default.oneOf([false, popups.TIME, popups.CALENDAR]),
    defaultCurrentDate: prop_types_1.default.instanceOf(Date),
    onSelect: prop_types_1.default.func,
    min: prop_types_1.default.instanceOf(Date),
    max: prop_types_1.default.instanceOf(Date),
    blacklistDates: prop_types_1.default.any,
    locale: prop_types_1.default.string,
    format: prop_types_1.default.any,
    timeFormat: prop_types_1.default.any,
    editFormat: prop_types_1.default.any,
    calendar: prop_types_1.default.bool,
    time: prop_types_1.default.bool,
    timeComponent: custom_prop_types_1.default.elementType,
    //popup
    dropUp: prop_types_1.default.bool,
    duration: prop_types_1.default.number,
    placeholder: prop_types_1.default.string,
    name: prop_types_1.default.string,
    initialView: prop_types_1.default.oneOf(viewEnum),
    finalView: prop_types_1.default.oneOf(viewEnum),
    autoFocus: prop_types_1.default.bool,
    disabled: custom_prop_types_1.default.disabled,
    readOnly: custom_prop_types_1.default.readOnly,
    selectOnly: custom_prop_types_1.default.selectOnly,
    parse: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.string), prop_types_1.default.string, prop_types_1.default.func]),
    'aria-labelledby': prop_types_1.default.string,
    'aria-describedby': prop_types_1.default.string,
    messages: prop_types_1.default.shape({
      calendarButton: prop_types_1.default.string,
      timeButton: prop_types_1.default.string
    }),
    onMove: prop_types_1.default.func,
    onKeyPress: prop_types_1.default.func,
    step: prop_types_1.default.number,
    busy: prop_types_1.default.bool
  });
  DateTimePicker.defaultProps = {
    value: undefined,
    min: new Date(1900, 0, 1),
    max: new Date(2099, 11, 31),
    calendar: true,
    time: true,
    duration: 200
  };
  return DateTimePicker;
}(react_1.default.PureComponent);
exports.DateTimePicker = DateTimePicker;